import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useTranslator } from "../i18n/translator.ts";

interface ButtonWithConfirmationProps {
  handleConfirm: () => void;
  dialogTitle: string;
  dialogMessage: string;
}

export const ButtonWithConfirmation: React.FC<
  React.PropsWithChildren<ButtonWithConfirmationProps>
> = ({ handleConfirm, dialogTitle, dialogMessage, children }) => {
  const translate = useTranslator();

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const onConfirm = () => {
    handleConfirm();
    setOpen(false);
  };
  return (
    <>
      <div onClick={handleOpen} color="error">
        {children}
      </div>
      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>{translate("cancel")}</Button>
          <Button onClick={onConfirm} color="error">
            {translate("confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
